/* ==========================================================================
   Funkissd — Cart quick add-ons
   Suggests cheap, RELEVANT add-ons (under $15) using Shopify's own
   /recommendations/products.json endpoint, seeded from the first item
   already in the cart. Nothing is hardcoded or fabricated: if no relevant
   low-cost recommendation exists, the strip just stays hidden.

   Used inside both snippets/cart-notification.liquid and
   snippets/cart-drawer.liquid. The container (#funkissd-cart-addons) is
   only server-rendered by Liquid when the cart is non-empty, so on a fresh
   page load with an empty cart it doesn't exist yet — init() must NOT bail
   out just because the container is missing at load time, otherwise the
   fetch-patch below never gets installed and the strip can never populate
   after the shopper's first add-to-cart. getContainer()/refreshAddons()
   re-query the DOM live on every call, so this works whether the container
   was there from the start or only appears later (e.g. after Dawn's own
   section-rendering swaps in fresh drawer/notification markup).
   ========================================================================== */
(function () {
  var MAX_ADDON_PRICE_CENTS = 1500;
  var MAX_ADDONS = 3;

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getContainer() {
    return document.getElementById('funkissd-cart-addons');
  }

  function renderAddons(products) {
    var container = getContainer();
    if (!container) return;
    var list = document.getElementById('funkissd-cart-addons__list');
    if (!list) return;

    if (!products.length) {
      container.hidden = true;
      list.innerHTML = '';
      return;
    }

    list.innerHTML = products
      .map(function (product) {
        var variant = product.variants && product.variants[0];
        if (!variant) return '';
        var image = product.featured_image || (product.images && product.images[0]) || '';
        return (
          '<div class="funkissd-cart-addons__item">' +
          (image
            ? '<img src="' + image + '&width=112" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="56" height="56">'
            : '') +
          '<span class="funkissd-cart-addons__item-title">' + (product.title || '') + '</span>' +
          '<span class="funkissd-cart-addons__item-price">' + moneyFormat(variant.price) + '</span>' +
          '<button type="button" class="funkissd-cart-addons__add" data-variant-id="' + variant.id + '">+ Add</button>' +
          '</div>'
        );
      })
      .join('');

    container.hidden = false;
  }

  function refreshAddons() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var container = getContainer();
        if (!cart.item_count || !container) {
          if (container) container.hidden = true;
          return;
        }

        var cartProductIds = cart.items.map(function (item) {
          return item.product_id;
        });
        var seedProductId = cart.items[0].product_id;

        // "complementary" (bought-together) recommendations need order
        // history this store hasn't built up yet and currently return
        // nothing, so we use "related" (catalog/collection similarity) —
        // still Shopify's own recommendation engine, not a hardcoded list.
        fetch(
          '/recommendations/products.json?product_id=' + seedProductId + '&limit=10&intent=related',
          { credentials: 'same-origin' }
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var products = (data.products || [])
              .filter(function (product) {
                if (cartProductIds.indexOf(product.id) !== -1) return false;
                var variant = product.variants && product.variants[0];
                return variant && variant.price <= MAX_ADDON_PRICE_CENTS && variant.available !== false;
              })
              .slice(0, MAX_ADDONS);
            renderAddons(products);
          })
          .catch(function () {
            var container2 = getContainer();
            if (container2) container2.hidden = true;
          });
      })
      .catch(function () {});
  }

  // Keeps the header cart-count bubble accurate after an add-on is added
  // without needing a full page reload or the theme's section-rendering
  // machinery (which this widget deliberately doesn't depend on, since it
  // lives outside the ajax-swapped notification subsections).
  function updateCartCountBubble(cart) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');

    if (!cart.item_count) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      link.appendChild(bubble);
    }

    if (cart.item_count < 100) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(span, bubble.firstChild);
      }
      span.textContent = cart.item_count;
    }

    var hiddenSpan = bubble.querySelector('.visually-hidden');
    if (hiddenSpan && /\d+/.test(hiddenSpan.textContent)) {
      hiddenSpan.textContent = hiddenSpan.textContent.replace(/\d+/, cart.item_count);
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(updateCartCountBubble)
      .catch(function () {});
  }

  function handleAddClick(event) {
    var button = event.target.closest && event.target.closest('.funkissd-cart-addons__add');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        button.textContent = 'Added!';
        button.classList.add('is-added');
        // The monkey-patched fetch below also catches this /cart/add.js call
        // and triggers refreshAddons()/refreshCartCount(), but we call them
        // directly too so the button's own add-on strip and the header
        // count feel instant rather than waiting on the patch's .then().
        refreshAddons();
        refreshCartCount();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
      });
  }

  function init() {
    // NOTE: deliberately does NOT bail out if the container isn't in the
    // DOM yet (e.g. a fresh page load with an empty cart) — the listeners
    // below must always be installed so the strip can appear later, once
    // the shopper actually adds something and Liquid renders it.
    document.addEventListener('click', handleAddClick);
    refreshAddons();

    // Catches cart writes that happen elsewhere in the theme (e.g. adding
    // the main bundle from the product form) so the add-ons strip and cart
    // count stay in sync even when this widget's own click handler wasn't
    // the one that changed the cart.
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartWrite) {
        result
          .then(function () {
            refreshAddons();
            refreshCartCount();
          })
          .catch(function () {});
      }
      return result;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
